import {EventCreationMode} from 'src/modules/event-create/constants';
import {contextualLinksValidation} from 'src/modules/event-create/validations/contextual-links-validation';
import {
    eventTriggerAttachmentValidation,
} from 'src/modules/event-create/validations/event-trigger-attachment-validation';
import {eventTypeValidation} from 'src/modules/event-create/validations/event-type-validation';
import {ChangeRequestContextualLink} from 'src/openapi/models/ChangeRequestContextualLink';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import {eventDataTypeValidation} from './attribute-data-type-validation';
import {attributeDescriptionValidation} from './attribute-description-validation';
import {attributeNameValidation} from './attribute-name-validation';
import {attributeValidation} from './attribute-validation';
import {eventCodeValidation} from './event-code-validation';
import {eventDescriptionValidation} from './event-description-validation';
import {eventSourceValidation} from './event-source-validation';
import {eventTriggerValidation} from './event-trigger-validation';
import {possibleValuesValidation} from './possible-values-validation';

export const changeRequestValidation = (
    mode: EventCreationMode,
    eventChangeRequest: EventChangeRequest,
    contextualLinks: ChangeRequestContextualLink[],
    triggerAttachments: TriggerAttachment[],
): string[] => {
    const attributesValidation = new Set(eventChangeRequest.attributes.flatMap(attribute => {
        return [
            ...attributeNameValidation(eventChangeRequest.attributes, attribute.name),
            ...attributeDescriptionValidation(attribute?.description || '', attribute?.id),
            ...eventDataTypeValidation(attribute.fieldType),
            ...possibleValuesValidation(attribute.possibleValues, attribute?.id),
        ];
    }));
    return [
        ...attributeValidation(eventChangeRequest.attributes),
        ...eventCodeValidation(eventChangeRequest.code),
        ...eventDescriptionValidation(eventChangeRequest.description),
        ...eventTriggerValidation(eventChangeRequest.trigger),
        ...eventSourceValidation(eventChangeRequest.source),
        ...eventTypeValidation(eventChangeRequest.type),
        ...contextualLinksValidation(contextualLinks),
        ...eventTriggerAttachmentValidation(mode, eventChangeRequest, triggerAttachments),
        ...attributesValidation,
    ];
};
